import { useState, useEffect } from 'react';

export default function WorkflowAnalyticsPage() {
  const [stats, setStats] = useState(null);
  const [recentRuns, setRecentRuns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch('/api/workflows/stats', { credentials: 'include' }).then(r => r.json()),
      fetch('/api/workflows?limit=100', { credentials: 'include' }).then(r => r.json()),
    ]).then(([statsData, wfData]) => {
      setStats(statsData.data?.stats || statsData.stats || {});
      setRecentRuns(wfData.data?.workflows || wfData.workflows || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin h-8 w-8 border-4 border-indigo-500 border-t-transparent rounded-full" /></div>;

  const s = stats || {};
  const total = parseInt(s.total) || 0;
  const active = parseInt(s.active) || 0;
  const totalRuns = parseInt(s.total_runs) || 0;
  const runsToday = parseInt(s.runs_today) || 0;

  const cards = [
    { label: 'Total Workflows', value: total, color: 'indigo' },
    { label: 'Active', value: active, color: 'green' },
    { label: 'Total Runs', value: totalRuns, color: 'blue' },
    { label: 'Runs Today', value: runsToday, color: 'amber' },
    { label: 'Paused', value: parseInt(s.paused) || 0, color: 'orange' },
    { label: 'Drafts', value: parseInt(s.draft) || 0, color: 'gray' },
  ];

  return (
    <div className="max-w-6xl mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Workflow Analytics</h1>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
        {cards.map(c => (
          <div key={c.label} className="bg-white rounded-xl border border-gray-200 p-4 shadow-sm text-center">
            <div className={`text-3xl font-bold text-${c.color}-600`}>{c.value}</div>
            <div className="text-xs text-gray-500 mt-1">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm mb-8">
        <h2 className="text-lg font-semibold mb-4">Workflows</h2>
        {recentRuns.length === 0 ? (
          <p className="text-gray-400 text-center py-8">No workflows yet. Create one to get started!</p>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-gray-500 border-b">
              <th className="pb-2">Name</th><th className="pb-2">Status</th><th className="pb-2">Trigger</th><th className="pb-2">Runs</th>
            </tr></thead>
            <tbody>
              {recentRuns.slice(0, 20).map(wf => (
                <tr key={wf.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="py-2 font-medium">{wf.name}</td>
                  <td><span className={`px-2 py-0.5 rounded-full text-xs ${wf.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>{wf.status}</span></td>
                  <td className="text-gray-500">{wf.trigger_type}</td>
                  <td>{wf.runs_count || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
